/** The available auth routes in the application */
export enum SecurityRoute {
    Issuer = 'issuer',
    RedirectUrl = 'redirect-url',
    ImplicitCallback = 'implicit-callback',
    PostLogout = 'post-logout'
}